import { useEffect, useState } from "react"

import { GetRequest } from "../../../Utils/hooks/ApiHandler"
import images from "../../../Utils/assets/img/chart/card-1.png"
import {
    ResponsiveContainer,
    CartesianGrid,
    AreaChart,
    Area,
    Tooltip as RechartTooltip,
    XAxis,
    YAxis,
} from "recharts"
import { toast } from "sonner"
import useLocalStorageState from "use-local-storage-state"
import { showServerError } from "../../../Utils/helpers/commonhelper"
export const DashboardCards = ({ show, heading, headers, extras }) => {
    const [customer, setCustomer] = useLocalStorageState('customer')
    const [contactCardData, setContactCardData] = useState(0)
    const [contactPerMonth, setContactPerMonth] = useState([])
    const [barCount, setBarCount] = useState(0)

    const contactCards = async () => {
        try {
            const res = await GetRequest(
                `contacts/contactCard/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                { headers },
                extras
            )

            if (res.status === "fail" || res.success === false) {
                return
            }

            setContactCardData(res.data)

            const data = res.data?.contactPerMonth?.map((c) => ({
                ...c,
                month: c.month?.slice(0, 3),
            }))
            setContactPerMonth(data)
            setBarCount(res.data?.contactPerMonth.length)
        } catch (error) {
            // toast.error("Error fetching filters")
            //shoservererror()()
            return
        }
    }

    useEffect(() => {
        contactCards()
    }, [heading, customer])

    return (
        <>
            {
                show &&
                <div className="row  mb-0 mt-3 w-100 ms-0">
                    <div className="col-md-6">
                        <div className="row">
                            {" "}
                            <div
                                className="col-xxl-6 col-lg-6 col-md-6 ps-0 newCardsHeading"
                                style={{ zIndex: 0 }}
                            >
                                <div className="card custom-card overflow-hidden">
                                    <div className="card-body pt-2 w-100 pb-2 ps-2">
                                        <div className="d-flex align-items-top justify-content-between">
                                            <div>
                                                <span
                                                    className="avatar avatar-md avatar-rounded"
                                                    style={{ background: "#3d9fd7" }}
                                                >
                                                    <i className="ti ti-briefcase fs-16"></i>
                                                </span>
                                            </div>
                                            <div className="flex-fill ms-3">
                                                <div className="flex-wrap">
                                                    <div>
                                                        <a
                                                            className="text-warning"
                                                            href="##"
                                                        >
                                                            <p
                                                                className=" mb-0"
                                                                style={{ fontWeight: 200, color: "#3d9fd7" }}
                                                            >
                                                                Contacts created by me
                                                            </p>
                                                            <h4
                                                                className="fw-semibold mt-1 d-flex fs-20 justify-content-between "
                                                                style={{ color: "black" }}
                                                            >
                                                                {contactCardData?.created_by_me || 0}
                                                                <div
                                                                    id="crm-total-deals"
                                                                    style={{
                                                                        width: 80,
                                                                        height: "auto",
                                                                        minHeight: "35px",
                                                                    }}
                                                                >
                                                                    <div
                                                                        id="apexchartsn21xcu4d"
                                                                        className="apexcharts-canvas apexchartsn21xcu4d apexcharts-theme-light d-flex justify-content-end align-items-centre"
                                                                        style={{ width: 100, height: 26 }}
                                                                    >
                                                                        <img src={images} style={{ width: 67 }} />
                                                                    </div>
                                                                </div>
                                                            </h4>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-flex align-items-center justify-content-between mt-1"
                                                    style={{ lineHeight: 1.2 }}
                                                >
                                                    <div>
                                                        <p className="mb-0 text-success fw-semibold">
                                                            {contactCardData?.currentMonth_byMe || 0}{" "}
                                                        </p>
                                                        <span className="text-muted op-7 fs-11">
                                                            Current month
                                                        </span>
                                                    </div>
                                                    <div className="text-end">
                                                        <p className="mb-0 text-success fw-semibold">
                                                            {contactCardData?.lastMonth_byMe || 0}{" "}
                                                        </p>
                                                        <span className="text-muted op-7 fs-11">
                                                            Last Month
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-xxl-6 col-lg-6 col-md-6 ps-0 newCardsHeading"
                                style={{ zIndex: 0 }}
                            >
                                <div className="card custom-card overflow-hidden">
                                    <div className="card-body pt-2 w-100 pb-2 ps-2">
                                        <div className="d-flex align-items-top justify-content-between">
                                            <div>
                                                <span className="avatar avatar-md avatar-rounded bg-secondary">
                                                    <i className="ti ti-wallet fs-16"></i>
                                                </span>
                                            </div>
                                            <div className="flex-fill ms-3">
                                                <div className="flex-wrap">
                                                    <div>
                                                        <a
                                                            className="text-warning"
                                                            href="##"
                                                        >
                                                            <p
                                                                className="text-secondary mb-0"
                                                                style={{ fontWeight: 200 }}
                                                            >
                                                                All Contacts
                                                            </p>
                                                            <h4
                                                                className="fw-semibold mt-1 d-flex fs-20 justify-content-between "
                                                                style={{ color: "black" }}
                                                            >
                                                                {contactCardData?.all_contact || 0}
                                                                <div
                                                                    id="crm-total-deals"
                                                                    style={{
                                                                        width: 80,
                                                                        height: "auto",
                                                                        minHeight: "35px",
                                                                    }}
                                                                >
                                                                    <div
                                                                        id="apexchartsn21xcu4d"
                                                                        className="apexcharts-canvas apexchartsn21xcu4d apexcharts-theme-light d-flex justify-content-end align-items-centre"
                                                                        style={{ width: 100, height: 26 }}
                                                                    >
                                                                        <img src={images} style={{ width: 67 }} />
                                                                    </div>
                                                                </div>
                                                            </h4>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div
                                                    className="d-flex align-items-center justify-content-between mt-1"
                                                    style={{ lineHeight: 1.2 }}
                                                >
                                                    <div>
                                                        <p className="mb-0 text-success fw-semibold">
                                                            {contactCardData?.currentMonth || 0}{" "}
                                                        </p>
                                                        <span className="text-muted op-7 fs-11">
                                                            Current Month
                                                        </span>
                                                    </div>
                                                    <div className="text-end">
                                                        <p className="mb-0 text-success fw-semibold">
                                                            {contactCardData?.lastMonth || 0}{" "}
                                                        </p>
                                                        <span className="text-muted op-7 fs-11">
                                                            Last Month
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="col-xxl-6 col-lg-6 col-md-6 ps-0 newCardsHeading"
                        style={{ zIndex: 0 }}
                    >
                        <div className="card custom-card overflow-hidden">
                            <div className="card-body pt-2 w-100 pb-2 ps-2">
                                <div className="d-flex align-items-top justify-content-between">
                                    <div>
                                        <span
                                            className="avatar avatar-md avatar-rounded"
                                            style={{ background: "#3faa5f" }}
                                        >
                                            <i className="ti ti-briefcase fs-16"></i>
                                        </span>
                                    </div>
                                    <div className="flex-fill ms-3">
                                        <div className="flex-wrap">
                                            <div>
                                                <a
                                                    className="text-warning"
                                                    href="##"
                                                >
                                                    <p
                                                        className=" mb-0"
                                                        style={{ fontWeight: 200, color: "#3faa5f" }}
                                                    >
                                                        Contacts by month
                                                    </p>
                                                </a>
                                                <div
                                                    className="d-flex justify-content-start mt-4"
                                                    style={{ width: "100%", height: 60 }}
                                                >
                                                    <ResponsiveContainer width="100%" height="120%">
                                                        <AreaChart
                                                            data={contactPerMonth}
                                                        >
                                                            <defs>
                                                                <linearGradient id="colorContact" x1="0" y1="0" x2="0" y2="1">
                                                                    <stop offset="5%" stopColor="#865adf" stopOpacity={0.8} />
                                                                    <stop offset="95%" stopColor="#865adf" stopOpacity={0} />
                                                                </linearGradient>
                                                            </defs>
                                                            <CartesianGrid
                                                                strokeDasharray="3 3"
                                                                vertical={false}
                                                                stroke="#f5f5f5"
                                                            />
                                                            <XAxis
                                                                dataKey="month"
                                                                axisLine={false}
                                                                tickLine={false}
                                                                tick={{ fill: "#677788", fontSize: 12 }}
                                                            />
                                                            <YAxis
                                                                axisLine={false}
                                                                tickLine={false}
                                                                tick={{ fill: "#677788", fontSize: 12 }}
                                                            />
                                                            <RechartTooltip
                                                                contentStyle={{
                                                                    borderRadius: "8px",
                                                                    border: "none",
                                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                                                }}
                                                            />
                                                            <Area
                                                                type="monotone"
                                                                dataKey="contact"
                                                                stroke="#865adf"
                                                                strokeWidth={1}
                                                                fillOpacity={1}
                                                                fill="url(#colorContact)"
                                                                dot={{ r: 2, fill: "#865adf" }}
                                                                activeDot={{ r: 6 }}
                                                            />
                                                        </AreaChart>
                                                    </ResponsiveContainer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <style jsx>
                        {`
           .recharts-bar-rectangle:hover {
             stroke: none !important;
           }
 
           .recharts-active-bar {
             stroke: none !important;
             stroke-width: 0 !important;
           }
 
           .recharts-bar-rectangle {
             stroke: none !important;
           }
         `}
                    </style>
                </div>
            }
        </>
    )
}
